import React from 'react';
import { Download } from 'lucide-react';
import ProgressBar from './ProgressBar';
import DocumentItem from './DocumentItem';
import FinalChecklist from './FinalChecklist';

const DocumentList = ({
  documents,
  uploadedDocs,
  uploadingDocs = {},
  onFileUpload,
  onGenerateLetter,
  onDownloadAll,
  onStartNew
}) => {
  const getProgressPercentage = () => {
    const required = documents.filter(d => d.required);
    const uploaded = required.filter(d => uploadedDocs[d.title]);
    return required.length > 0 ? (uploaded.length / required.length) * 100 : 0;
  };

  return (
    <div className="container">
      <div className="card">
        <div className="header">
          <h1>Your Visa Documents</h1>
          <button className="btn btn-secondary" onClick={onStartNew}>
            Start New Application
          </button>
        </div>
        
        <ProgressBar percentage={getProgressPercentage()} />

        <div className="documents-list">
          {documents.map((doc, index) => (
            <DocumentItem
              key={index}
              document={doc}
              uploadedDoc={uploadedDocs[doc.title]}
              isUploading={uploadingDocs[doc.title]}
              onFileUpload={onFileUpload}
            />
          ))}
        </div>

        <div className="actions">
          <button className="btn btn-primary" onClick={onDownloadAll}>
            <Download size={20} />
            Download All Documents
          </button>
          
          <button 
            className="btn btn-secondary" 
            onClick={() => onGenerateLetter('Cover Letter')}
          >
            Generate Cover Letter
          </button>
          
          <button 
            className="btn btn-secondary" 
            onClick={() => onGenerateLetter('Purpose Statement')}
          >
            Generate Purpose Statement
          </button>
        </div>

        <FinalChecklist />
      </div>
    </div>
  );
};

export default DocumentList;